<template>
  <div
    v-if="adsmartUI"
    class="container"
    :style="{
      maxWidth: containerWidth
    }"
  >
    <div class="container-width-options">
      container current width: {{ containerWidth }} options :
      <input
        id="sm"
        v-model="containerWidth"
        type="radio"
        value="calc(390px + 18px)"
        :checked="
          $route.params.device === 'APP' || $route.params.device === 'MOBILE'
        "
      />
      <label for="sm">container-sm</label>
      <input
        id="lg"
        v-model="containerWidth"
        type="radio"
        value="calc(1024px + 18px)"
        :checked="$route.params.device === 'PC'"
      />
      <label for="lg">container-lg</label>
      <input id="fluid" v-model="containerWidth" type="radio" value="100%" />
      <label for="fluid">container-fluid</label>
    </div>
    <div v-for="boardInfo in boards" :key="boardInfo.identify" class="board">
      <div>
        {{
          [
            boardInfo.name,
            `board identify: ${boardInfo.identify}`,
            `type id: ${boardInfo.typeId}`
          ].join(" | ")
        }}
      </div>
      <div v-if="getAdsmartBoard(boardInfo.identify)">
        {{
          [
            `type mode: ${getAdsmartBoardTypeMode(boardInfo.identify)}`,
            "shelfId: " + getAdsmartBoardShelfId(boardInfo.identify)
          ].join(" | ")
        }}
      </div>
      <div v-else style="color: red">--無廣告資料--</div>
      <hr />

      <template
        v-if="
          getAdsmartBoardTypeMode(boardInfo.identify) === MODE_ENUM.KEYWORD ||
          getAdsmartBoardTypeMode(boardInfo.identify) ===
            MODE_ENUM.COMPOSE_KEYWORD
        "
      >
        <input v-model="keyword" type="text" placeholder="請輸入關鍵字" />
        <CustomElementRenderer
          :board-info="boardInfo"
          :ads-keyword-input="keyword"
        ></CustomElementRenderer>
      </template>

      <CustomElementRenderer
        v-else-if="
          getAdsmartBoardTypeMode(boardInfo.identify) === MODE_ENUM.CUSTNO ||
          getAdsmartBoardTypeMode(boardInfo.identify) ===
            MODE_ENUM.COMPOSE_CUSTNO
        "
        :board-info="boardInfo"
        :ads-custno="getAdsmartBoardCostno(boardInfo.identify)"
      ></CustomElementRenderer>

      <template
        v-else-if="
          getAdsmartBoardTypeMode(boardInfo.identify) === MODE_ENUM.DYNAMIC ||
          getAdsmartBoardTypeMode(boardInfo.identify) ===
            MODE_ENUM.COMPOSE_DYNAMIC
        "
      >
        <template v-for="n in boardInfo.upperLimit">
          <div :key="n">
            {{ n }}
            <CustomElementRenderer
              :board-info="boardInfo"
            ></CustomElementRenderer>
          </div>
        </template>
      </template>

      <CustomElementRenderer
        v-else
        :board-info="boardInfo"
      ></CustomElementRenderer>
    </div>
  </div>
</template>

<script>
import {
  MODE_ENUM,
  default as typeConfig
} from "@/adsmart-ui/settings/typesConfig.js";
import mockComposeTypeData from "@/data/mockComposeTypeData.js";
import mockComposeTypeBoard from "@/data/mockComposeBoard.js";
import CustomElementRenderer from "@/components/mockPage/customElementRenderer.vue";

export default {
  name: "MockPage",
  components: {
    CustomElementRenderer
  },
  data() {
    return {
      MODE_ENUM,
      dataMaps: window.dataMaps,
      adsmartData: null,
      adsmartUI: null,
      keyword: "",
      containerWidth: ""
    };
  },
  computed: {
    boards() {
      if (this.$route.params.env === "dev") {
        return mockComposeTypeBoard;
      }
      let bInfos = [];
      this.dataMaps.cMap.get(this.$route.params.channel).forEach(bInfo => {
        const board = bInfo.env.get(this.$route.params.env);
        if (board) {
          bInfos.push(board);
        }
      });
      return bInfos;
    }
  },
  mounted() {
    window.adsmartUI = new window.AdsmartUI();
    const { env, channel } = this.$route.params;
    this.mockEnvEntry(env, channel);
  },
  methods: {
    injectEnvData(env, channelIdentify, conditions) {
      if (env === "dev") {
        return Promise.resolve(mockComposeTypeData);
        // env = "lab";
      }
      const domains = {
        lab: "aidma.adsmart.104-dev.com.tw",
        staging: "aidma.adsmart.104-staging.com.tw",
        prod: "aidma.adsmart.104.com.tw"
      };

      const domain = domains[env] || domains.prod;

      const url = new URL(`https://${domain}/channel/${channelIdentify}`);
      if (conditions) {
        Object.entries(conditions).forEach(([key, value]) => {
          url.searchParams.append(key, value);
        });
        url.searchParams.append("condition", 1);
      }

      return window.fetch(url).then(response => response.json());
    },
    mockEnvEntry(...args) {
      return this.injectEnvData.apply(null, args).then(adsmartData => {
        window.adsmartUI.inject(args[1], adsmartData);
        this.adsmartData = adsmartData;
        this.adsmartUI = window.adsmartUI;
      });
    },
    getAdsmartBoard(bHash) {
      const channel = window.adsmartUI?.channelsMap?.get(
        this.$route.params.channel
      );
      return channel?.boardsMap?.get(bHash);
    },
    getAdsmartBoardTypeMode(bHash) {
      const typeId = this.getAdsmartBoard(bHash)?.typeId;
      const mode = typeConfig[typeId]?.mode;
      return mode;
    },
    getAdsmartBoardShelfId(bHash) {
      return this.getAdsmartBoard(bHash)
        ?._rawMaterials.map(el => el.shelfId)
        .join("/");
    },
    getAdsmartBoardCostno(bHash) {
      return this.getAdsmartBoard(bHash)?._rawMaterials?.[0]?.contents?.[1]
        ?.element;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 8px;
  &-lg {
    max-width: (1024px + 34px);
  }
  &-sm {
    max-width: (390px + 34px);
  }

  &-width-options {
    button {
      margin: 0 8px;
    }
  }
}

.board {
  border: 1px solid gray;
  margin: 8px 0;
  padding: 8px;
  input {
    display: block;
    margin: 8px 0;
    height: 1.5rem;
  }
}
</style>
